// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useCategoryPageSplitFilterQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/__internal__/useCategoryPageSplitFilterQuery/useCategoryPageSplitFilterQuery";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useCategoryPageQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageQuery";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useLayoutElementsResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/useLayoutElementsResponse";
/**
 * Calling these hooks starts data fetching.
 * Rendering this component besides the lazy page component achieves prefetching.
 */ export var CategoryPagePrefetcher = function() {
    useCategoryPageQuery();
    useCategoryPageSplitFilterQuery();
    useLayoutElementsResponse();
    return null;
};
